import i18n from "../i18n";

export type CancelFunction = () => void;

// The backend reads this to localize store data (item/category names, errors, ...). It's the
// player's selected UI language, which doesn't necessarily match the browser's Accept-Language.
export function withLanguage(init?: RequestInit): RequestInit {
    const headers = new Headers(init?.headers);
    headers.set("Accept-Language", i18n.language);
    return {...init, headers};
}

export default function fetchWithRetry(
    callback: (res: Response) => boolean | Promise<Boolean>,
    input: RequestInfo | URL,
    init?: RequestInit,
    interval: number = 5000
): CancelFunction {
    let timeout: NodeJS.Timeout | undefined;
    let cancelled = false;

    function cancel() {
        cancelled = true;
        if (timeout) clearTimeout(timeout);
    }

    function makeRequest() {
        if (cancelled) return;
        fetch(input, withLanguage(init)).then(res => {
            if (!cancelled) return callback(res);
            return true;
        }).then(v => {
            if (!v) timeout = setTimeout(makeRequest, interval);
            else cancel();
        }).catch(() => setTimeout(makeRequest, interval))
    }

    makeRequest();

    return cancel;
}